import { createSlice } from '@reduxjs/toolkit'

import { DevLogsApi } from 'shared/api/requests/devLogs'
import { type PolicyEnforcementLogItem } from 'shared/api/requests/devLogs/schemas'
import { createAsyncAction } from 'shared/lib/redux/createAsyncAction'

export interface PolicyEnforcementState {
  logs?: PolicyEnforcementLogItem[]
  fetching: boolean
}

export const fetchPolicyEnforcementLogs = createAsyncAction(
  'policyEnforcement/fetchLogs',
  async () => {
    const response = await DevLogsApi.fetchPolicyEnforcementLogs()
    return response.data
  },
  {
    errorMarkupOptions: { scope: 'settings', section: 'dev_logs' },
  },
)

const initialState: PolicyEnforcementState = {
  fetching: false,
}

const policyEnforcementSlice = createSlice({
  name: 'policyEnforcement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase('APP_UPDATE_CURRENT_ACCOUNT_ID', () => initialState)
    builder.addCase(fetchPolicyEnforcementLogs.pending, (state) => {
      state.fetching = true
    })
    builder.addCase(fetchPolicyEnforcementLogs.fulfilled, (state, action) => {
      state.logs = action.payload.logs
      state.fetching = false
    })
    builder.addCase(fetchPolicyEnforcementLogs.rejected, (state) => {
      state.fetching = false
    })
  },
})

export default policyEnforcementSlice.reducer
